import React from 'react';
import { Alert } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

interface StampAlertsProps {
  error: string | null;
  success: string | null;
}

export const StampAlerts: React.FC<StampAlertsProps> = ({ error, success }) => {
  return (
    <>
      {error && (
        <Alert variant="danger" className="mb-4">
          {error}
        </Alert>
      )}

      {success && (
        <Alert variant="success" className="mb-4">
          {success}
        </Alert>
      )}

      <Alert variant="info" className="mb-4">
        <Icon.InfoCircle className="me-2" />
        Tutaj możesz zarządzać swoimi pieczątkami. Obsługiwane formaty: PNG,
        JPG, JPEG. Maksymalny rozmiar pliku: 500kb (0,5MB). Pieczątka i podpis
        powinny mieć przezroczyste tło i powinny być czytelne w pokazanych
        okienkach. <br />
        <b>Uwaga:</b> Jeśli nie widzisz szachownicy pod obrazkiem, oznacza, że
        tło obrazka nie jest przezroczyste.
        <br />
        <br />
        Kliknij na obrazek, aby zmienić pieczątkę/podpis.
      </Alert>
    </>
  );
};
